// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"a067763b","191":"a9c3efb5","367":"06f24f86"}[chunkId] + ".chunk.js";
};